import './styles.css';
import React from 'react';
import useFlagsFromBackend, { GB_FLAGS } from '../../../legacy_components/services/launchDarkly';
import pepsiLogo from '../../../assets/img/pepsi-logo.svg';
import dellLogo from '../../../assets/img/dell-logo.svg';
import redditLogo from '../../../assets/img/reddit-logo-social-proof.svg';
import disneyLogo from '../../../assets/img/disney-logo.svg';


export default function LogoCompanies () {
  const { $flagsReady, show_companies_and_testimonial } = useFlagsFromBackend([GB_FLAGS.show_companies_and_testimonial]);
  if ($flagsReady && show_companies_and_testimonial) {
    return (
      <div className="logo-companies">
        <p className="grey-text">Companies we are hiring for</p>
        <div className="top-logo">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/c/cd/Johnson_and_Johnson_Logo.svg/1200px-Johnson_and_Johnson_Logo.svg.png?20210105225048"
            className="logo-jsj"
            alt="jsj"
          />
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/e/e9/Pepsi_logo_2008.svg/300px-Pepsi_logo_2008.svg.png"
            className="logo-pepsi"
            alt="pepsi"
          />
        </div>
        <div className="bottom-logo">
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/4/48/Dell_Logo.svg/450px-Dell_Logo.svg.png?20160807135325"
            className="logo-dell"
            alt="dell"
          />
          <img
            src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a4/Disney_wordmark.svg/1050px-Disney_wordmark.svg.png"
            className="logo-disney"
            alt="disney"
          />
          <img
            src="https://1000logos.net/wp-content/uploads/2022/03/Coinbase-logo-768x473.png"
            className="logo-coinbase"
            alt="coinbase"
          />

        </div>
        <div className="text-bottom">and 200+ more companies!</div>
        <hr className="bottom-line" />
      </div>
    );
  } else {
    return <></>;
  }
}

export const SocialProofLogo = () => {
  return (
    <div className="social-proof-logo-companies">
      <p className="top-logo-header">Companies we are hiring for</p>
      <div className="social-proof-logo-row">
        <img
          src={pepsiLogo}
          className="social-proof-logo-pepsi"
          alt="pepsi"
        />
        <img
          src={dellLogo}
          className="social-proof-logo-dell"
          alt="dell"
        />
      </div>
      <div className="social-proof-logo-row">
          <img
              src={redditLogo}
              className="social-proof-logo-reddit"
              alt="reddit"
            />
          <img
            src={disneyLogo}
            className="social-proof-logo-disney"
            alt="disney"
          />
      </div>
      <div className="social-proof-logo-row">

        <img
          src="/images/companies/volvo.svg"
          alt="volvo"
        />
      </div>
      <div className="text-bottom-social-proof">and 200+ more companies!</div>
    </div>
  )
}
